// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61ed48e7","488":"93547b99","667":"1aa5a80c","923":"13fa43f1"}[chunkId] + ".chunk.js";
};